var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFooterFixedDocs = function SvgIconFooterFixedDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3038",
    d: "M13.667 6.793H11.74a2.87 2.87 0 0 1-2.866-2.867V2c0-.367-.3-.667-.667-.667H5.38c-2.053 0-3.713 1.333-3.713 3.713v5.907c0 2.38 1.66 3.713 3.713 3.713h5.24c2.054 0 3.714-1.333 3.714-3.713V7.46c0-.367-.3-.667-.667-.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M10.534 1.474c-.274-.274-.747-.087-.747.293v2.327c0 .973.827 1.78 1.833 1.78.634.006 1.514.006 2.267.006.38 0 .58-.446.313-.713-.96-.967-2.68-2.707-3.666-3.693"
  })));
};
export default SvgIconFooterFixedDocs;